export const cartReducer= (state,action)=>{
    switch (action.type) {
        case "ADD_PRODUCT":
            return {...state,cart:[...state.cart,{...action.payload, qty:1}]}
       case "REMOVE_PRODUCT":
                return {...state, cart:state.cart.filter(c=>c.Id !== action.payload.Id)
                }   
        case "EMPTY_CART" :
        return {cart:[]}
        default:
        return state;
    }
}

export const RfqReducer=(state,action)=>{
    switch (action.type) {
        case "ADD_QUOTE":
            return {...state,coti:[...state.coti,{...action.payload}]}
         
        default:
        return state;
    }

}

//product Reducer   
export const productReducer=(state,action)=>{
    switch (action.type) {
        case 'SORT_BY_CATEGORY': 
        return {...state, byName:[...state.byName,{...action.payload}]}
        case 'CLEAR_FROM_SORT':
        return {...state, byName:state.byName.filter(c => c.Name !== action.payload)}
        case "FILTER_BY_SEARCH":
        return {...state, Query:action.payload}  
        case "Filter_By_Brand":
            return {...state, byBrand:[...state.byBrand,{...action.payload}]}
        case "CLEAR_FILTERS":
            return{
                byCategory:false,
                Query:"",
                byName:[]
            } 
        case "Add_All":
            return{...state,byName:[...state.byName,{...action.payload}]}
        case "UNIQUE_CATEGORY":    
        return{...state, byName:[action.payload]}
        default:
            return state;
    }
}

//reducer for user registration 
export const UserReducer=(state,action)=>{
    switch(action.type){
    case "ADD_USER":
        // notice the usage of input and value for this user forms 
        return {...state, [action.payload.input]:action.payload.value}

        default:
            return state; 
}};

//reducer for ticket registration 
export const TicketReducer=(state,action)=>{
    switch(action.type){
    case "ADD_TICKET":
        // notice the usage of input and value for forms 
        return {...state, [action.payload.input]:action.payload.value}
        default:
            return state; 
}};

//reducer for distributor registration 
export const DistributorReducer=(state,action)=>{
    switch(action.type){
    case "ADD_Distributor":
        // notice the usage of input and value for forms 
        return {...state, [action.payload.input]:action.payload.value}
        default:
            return state; 
}};
